import { size as inputSizeProps } from '@/styles/theme/components/input';
import {
    Box,
    Center,
    forwardRef,
    InputProps,
    useRadio,
} from '@chakra-ui/react';
import { RadioInputProps } from './RadioInput';

const RadioCardInput = forwardRef<RadioInputProps, 'input'>(
    (
        {
            id,
            name,
            value,
            isChecked,
            defaultChecked,
            isDisabled,
            isFocusable,
            isReadOnly,
            isInvalid,
            isRequired,
            onChange,
            color = 'blue',
            size = 'md',
            children,
            ...rest
        },
        ref
    ) => {
        const { getInputProps, getCheckboxProps } = useRadio({
            id,
            name,
            value,
            isChecked,
            defaultChecked,
            isDisabled,
            isFocusable,
            isReadOnly,
            isInvalid,
            isRequired,
            onChange,
        });

        const input = getInputProps();
        const checkbox = getCheckboxProps();
        const sizeProps = inputSizeProps[size] as InputProps;

        return (
            <Box as="label" {...rest}>
                <input {...input} ref={ref} />
                <Center
                    {...sizeProps}
                    {...checkbox}
                    {...rest}
                    bg="white"
                    cursor="pointer"
                    borderWidth="1px"
                    boxShadow="sm"
                    _checked={{
                        color: color + '.500',
                        bg: 'white',
                        borderColor: color + '.500',
                    }}
                    _focus={{
                        boxShadow: 'outline',
                    }}
                    px={4}
                    py={2}
                >
                    {children}
                </Center>
            </Box>
        );
    }
);

export default RadioCardInput;
